import React from 'react'
import Typography from '@mui/material/Typography'
import { Address as AddressType } from '../../../../types/address'

const Address = (props: AddressType) => {
  return (
    <Typography
      sx={theme => ({
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.333,
        marginBottom: theme.spacing(0.75),
      })}
    >
      {props.line1},{props.line2 ? ` ${props.line2}` : ''} ${props.city}, $
      {props.state} ${props.postalCode}
    </Typography>
  )
}

export default Address
